//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';
export default {
  name:"source-base",
  components:{
    DivSpan
  },
  props:['sourceDto']
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/source-base.vue